import {useEffect} from 'react'

import {useSelector} from '../../../store.js'
import {
  getAPIKeys,
  activeAPIKeysSortedByNameSelector,
} from '../../../data/apiKeys.js'
import {
  canManageUserPermissionSelector,
  usesAPIKeysSelector,
} from '../../../data/me.js'
import SettingsPanel from '../SettingsPanel.js'
import APIKeysFeaturePage from './APIKeysFeaturePage.js'
import {showGlobalError} from '../../GlobalErrorMessage.js'
import {apiKeyEditIDSelector, apiKeyIsNewSelector} from './apiKeysFunctions.js'
import Item from './Item.js'

async function refreshAPIKeys() {
  try {
    await getAPIKeys()
  } catch (err) {
    showGlobalError(
      {
        summary: 'Error getting API Keys.',
        details: err.message || err.error_message,
      },
      `Error getting API Keys. ${err.error_message || err.message}`,
      err,
    )
  }
}

export default function APIKeys() {
  const apiKeys = useSelector(activeAPIKeysSortedByNameSelector)
  const canManageUser = useSelector(canManageUserPermissionSelector)
  const usesAPIKeys = useSelector(usesAPIKeysSelector)
  const editID = useSelector(apiKeyEditIDSelector)
  const isNew = useSelector(apiKeyIsNewSelector)

  useEffect(() => {
    if (usesAPIKeys) {
      refreshAPIKeys()
    }
  }, [usesAPIKeys])

  if (!usesAPIKeys) {
    return <APIKeysFeaturePage />
  }

  return (
    <SettingsPanel header="API Keys">
      <div className="row">
        <div className="medium-12 columns">
          <ul className="settings-list">
            {apiKeys.map((apiKey) => (
              <Item
                key={apiKey.id}
                apiKey={apiKey}
                isExpanded={apiKey.id === editID}
              />
            ))}
            {canManageUser && <Item isExpanded={isNew} />}
          </ul>
        </div>
      </div>
    </SettingsPanel>
  )
}
